/* global tw */
import React from 'react'
import { graphql, Link } from 'gatsby'
import { Textfit } from 'react-textfit'
import CodeBlock from './CodeBlock'
import Layout from './Layout'

/* fontFamily: 'avenir' */
const Template = props => {
  const post = props.data.mdx
  const { next, prev, timeToRead, wordCount, frontMatter } = props.pageContext
  return (
    <Layout>
      <h1>
        <Textfit mode="single">{frontMatter.title}</Textfit>
      </h1>
      <div>
        <em>{timeToRead} min</em>({wordCount} words)
      </div>
      <CodeBlock content={post.code.body} />
      <div>
        {next && (
          <Link to={next.fields.slug}>Next: {next.frontmatter.title}</Link>
        )}
      </div>
      <div>
        {prev && (
          <Link to={prev.fields.slug}>Previous: {prev.frontmatter.title}</Link>
        )}
      </div>
    </Layout>
  )
}

export default Template

export const pageQuery = graphql`
  query MDXRuntimeQuery($id: String!) {
    mdx(id: { eq: $id }) {
      id
      code {
        body
      }
    }
  }
`
